import React from "react";
import { LiveSentimentContainer } from "./styles";
import AreaGraphCard from "../AreaGraphCard";
import { DurationOptions } from "../DurationSelector/constants";
import DashboardService from "../../../../../../services/Dashboard";

function LiveSentiment({ duration, selectedStock }) {
  const [sentiment, setSentiment] = React.useState(false);
  React.useEffect(() => {
    if(!selectedStock){
      return;
    }
    setSentiment(false);
    DashboardService.getSentimentGraphData(selectedStock.nasdaq,DurationOptions[duration].timeRange).then((data) => {
      setSentiment(data);
    }).catch(e=>{
      if(e?.response?.data){
        setSentiment(e.response.data.message || e.response.data.detail);
      }
      else{
        setSentiment(e.message || "Failed to load sentiment data.");
      }
    });
  }, [duration, selectedStock]);
  return (
    <LiveSentimentContainer>
      <AreaGraphCard
        title={"Live Sentiment"}
        selectedStock={selectedStock}
        data={sentiment}
        duration={duration}
        yLabel={"Sentiment"}
        unit={""}
        formatter={(value)=>value.toFixed(2)}
      />
    </LiveSentimentContainer>
  );
}
export default LiveSentiment;
